import React, { Component } from "react";
import LoginForm from "./components/LoginForm";
import LayoutIndex from "./components/layouts/LayoutIndex";
import OTPConfirm from "./components/OTPConfirm";
import Layout from "./components/layouts/Layout";
import About from "./components/pages/About";
import HomePage from "./components/pages/HomePage";
import RegisterForm from "./components/RegisterForm";
import ContactUs from "./components/pages/ContactUs";
import LoadingCircular from "./components/LoadingCircular";
import Products from "./components/pages/Products";
import Shemsh from "./components/pages/pageComponents/Shemsh";
import Bilet from "./components/pages/pageComponents/Bilet";
import NimKoreh from "./components/pages/pageComponents/NimKoreh";
import SabtSefaresh from "./components/pages/SabtSefaresh";
import HamkariBaMa from "./components/pages/HamkariBaMa";
import Enteghadat from "./components/pages/Enteghadat";
import EstekhdamForm from "./components/pages/Estekhdam";
import MasrafKonandehForm from "./components/pages/MasrafKonandeh";
import Eftekharat from "./components/pages/Eftekharat";
import TamasBaKarshenas from "./components/pages/TamasBaKarshenas";
import UserProfile from "./components/pages/UserProfile";
import Peygiriha from "./components/pages/Peygiriha";
import OrderStatus from "./components/pages/OrderStatus";
import GetCertificate from "./components/pages/GetCertificate";
import GalleryDefault from "./components/pages/GalleryDetail";
import Gallery from "./components/pages/Gallery";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";
import Message from "./components/pages/Message";
import News from "./components/pages/News";
import NewsDetail from "./components/pages/NewsDetail";

class App extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };
  state = {
    loginStep: 1,
    mobile: "",
    NameFamily: "",
    CompanyName: "",
    OTP: "",
    requestToken: this.props.cookies.get("requestToken") || "",
    accessToken: this.props.cookies.get("accessToken") || "",
    componentToShow: "",
    isLoading: false,
    arrowBackEnable: false,
    menuStack: [],
    newsId: 0,
    galleryId: 0,
    galleryTitle: "",
    galleryDate: "",
  };
  updateCookie = (name, value) => {
    const { cookies } = this.props;
    var exp_date = new Date();
    exp_date.setDate(exp_date.getDate() + 30);
    cookies.set(name, value, { path: "/", expires: exp_date });
    //this.setState({ accessToken: cookies.get("accessToken") });
  };
  apiBase = "https://37.255.236.157:5000";
  componentDidMount() {
    //const access_token = localStorage.getItem("accessToken");
    //const name_family = localStorage.getItem("nameFamily");
    const access_token = this.props.cookies.get("accessToken") || "";
    const name_family = this.props.cookies.get("nameFamily") || "";
    const request_token = this.props.cookies.get("requestToken") || "";

    //this.setState({ accessToken: access_token });
    console.log("access token is:", access_token);
    if (access_token !== "") {
      this.setState({
        accessToken: access_token,
        mobile: access_token,
        NameFamily: name_family,
        request_token: request_token,
      });
    }
  }

  handleChange = (e, attr) => {
    // console.log(attr, e.target.value);

    this.setState({ [attr]: e.target.value });
  };

  handleLogin = async () => {
    const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
    if (this.state.mobile === "") {
      alert("شماره موبایل وارد نشده است");
      return;
    }
    this.setState({ isLoading: true });
    const data = await fetch(`/ng/api/Login/${p2e(this.state.mobile)}`);
    const res = await data.json();
    //check res
    console.log(res.requestToken);
    this.setState({
      loginStep: 2,
      requestToken: res.requestToken,
      isLoading: false,
    });
  };
  backToLogin = () => {
    this.setState({ loginStep: 1 });
  };
  handleOTPConfirm = async () => {
    this.setState({ isLoading: true });
    const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
    const _otp = p2e(this.state.OTP);
    const res = await fetch(`/ng/api/Login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        requestToken: this.state.requestToken,
        OTP: _otp,
      }),
    });
    const data = await res.json();
    this.setState({ isLoading: false });
    if (data.Challenge === "Ok") {
      if (data.newUser === 1) this.setState({ loginStep: 3 });
      else {
        //localStorage.setItem("accessToken", p2e(this.state.mobile));
        this.updateCookie("accessToken", p2e(this.state.mobile));
        this.updateCookie("requestToken", this.state.requestToken);
        const data = await fetch(
          `/ng/api/UserRegister/${p2e(this.state.mobile)}`
        );
        const res = await data.json();
        //localStorage.setItem("nameFamily", res.NameFamily);
        this.updateCookie("nameFamily", res.NameFamily);
        this.setState({
          accessToken: this.state.mobile,
          NameFamily: res.NameFamily,
          CompanyName: res.componentName,
        });
      }
    } else alert(data.Reason);
  };
  handleRegister = async (NameFamily, CompanyName) => {
    const mobile = this.state.mobile;
    const res = await fetch(`/ng/api/UserRegister`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ mobile, NameFamily, CompanyName }),
    });
    const data = await res.json();
    if (data.Result === "Ok") {
      //localStorage.setItem("accessToken", this.state.mobile);
      this.updateCookie("accessToken", this.state.mobile);
      this.updateCookie("nameFamily", NameFamily);
      this.updateCookie("requestToken", this.state.requestToken);
      this.setState({
        accessToken: this.state.mobile,
        NameFamily: NameFamily,
        CompanyName: CompanyName,
      });
    }
  };
  handleProfileUpdate = (nameFamily) => {
    //localStorage.setItem("nameFamily", nameFamily);
    this.updateCookie("nameFamily", nameFamily); // exp date nabayad inja update beshe
    this.setState({
      NameFamily: nameFamily,
    });
  };
  handleComToShow = (componentName) => {
    if (componentName === "logout") {
      //localStorage.removeItem("accessToken");
      //localStorage.removeItem("nameFamily");
      this.props.cookies.remove("accessToken");
      this.props.cookies.remove("nameFamily");
      this.props.cookies.remove("requestToken");
      this.setState({ loginStep: 1, componentToShow: "", accessToken: "" });
      window.location.reload();
    } else {
      if (componentName === "")
        this.setState({ arrowBackEnable: false, menuStack: [] });
      else {
        this.setState({
          arrowBackEnable: true,
          menuStack: [...this.state.menuStack, this.state.componentToShow],
        });
      }
      this.setState({ componentToShow: componentName });
    }
  };
  handleBack = () => {
    if (this.state.menuStack.length > 0) {
      const lastComponent = this.state.menuStack.pop();
      if (this.state.menuStack.length === 0)
        this.setState({ arrowBackEnable: false });
      this.setState({ componentToShow: lastComponent });
    }
  };
  handleNewsDetail = (id) => {
    this.setState({ newsId: id });
  };
  handleGalleryDetail = (id, title, date) => {
    this.setState({ galleryId: id, galleryTitle: title, galleryDate: date });
  };
  render() {
    const { loginStep, accessToken, componentToShow, isLoading } = this.state;
    if (accessToken === "") {
      switch (loginStep) {
        case 1:
          return (
            <LayoutIndex>
              <LoadingCircular open={isLoading} />
              <LoginForm
                handleChange={this.handleChange}
                handleLogin={this.handleLogin}
                mobileNumber={this.state.mobile}
              />
            </LayoutIndex>
          );
        case 2:
          return (
            <LayoutIndex>
              <LoadingCircular open={isLoading} />
              <OTPConfirm
                handleChange={this.handleChange}
                backToLogin={this.backToLogin}
                handleOTPConfirm={this.handleOTPConfirm}
              />
            </LayoutIndex>
          );
        case 3:
          return (
            <LayoutIndex>
              <RegisterForm handleRegister={this.handleRegister} />
            </LayoutIndex>
          );
        default:
      }
    } else {
      switch (componentToShow) {
        case "contact":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <ContactUs />
            </Layout>
          );
        case "message":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <Message mobileNumber={this.state.mobile} />
            </Layout>
          );
        case "eftekharat":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <Eftekharat />
            </Layout>
          );
        case "about":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <About />
            </Layout>
          );
        case "products":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <Products handleComToShow={this.handleComToShow} />
            </Layout>
          );
        case "shemsh":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <Shemsh />
            </Layout>
          );
        case "bilet":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <Bilet />
            </Layout>
          );
        case "nimkoreh":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <NimKoreh />
            </Layout>
          );
        case "sabtsefaresh":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <SabtSefaresh mobileNumber={this.state.mobile} />
            </Layout>
          );
        case "gallery":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <Gallery
                handleComToShow={this.handleComToShow}
                handleGalleryDetail={this.handleGalleryDetail}
              />
            </Layout>
          );
        case "gallerydetail":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <GalleryDefault
                galleryId={this.state.galleryId}
                galleryTitle={this.state.galleryTitle}
              />
            </Layout>
          );
        case "enteghadat":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <Enteghadat
                mobile={this.state.mobile}
                nameFamily={this.state.NameFamily}
              />
            </Layout>
          );
        case "hamkaribama":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <HamkariBaMa handleComToShow={this.handleComToShow} />
            </Layout>
          );
        case "estekhdam":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <EstekhdamForm mobileNumber={this.state.mobile} />
            </Layout>
          );
        case "masrafkonandeh":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <MasrafKonandehForm mobileNumber={this.state.mobile} />
            </Layout>
          );
        case "tamasbakarshenas":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <TamasBaKarshenas
                requestToken={this.state.requestToken}
                mobileNumber={this.state.mobile}
              />
            </Layout>
          );
        case "news":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <News
                handleComToShow={this.handleComToShow}
                handleNewsDetail={this.handleNewsDetail}
              />
            </Layout>
          );
        case "newsdetail":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <NewsDetail newsId={this.state.newsId} />
            </Layout>
          );
        case "userprofile":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <UserProfile
                mobileNumber={this.state.mobile}
                handleProfileUpdate={this.handleProfileUpdate}
              />
            </Layout>
          );
        case "peygiriha":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <Peygiriha handleComToShow={this.handleComToShow} />
            </Layout>
          );
        case "certificate":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <GetCertificate />
            </Layout>
          );
        case "orderstatus":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <OrderStatus />
            </Layout>
          );
        case "":
          return (
            <Layout
              handleComToShow={this.handleComToShow}
              handleBack={this.handleBack}
              mobileNumber={this.state.mobile}
              NameFamily={this.state.NameFamily}
              arrowBackEnable={this.state.arrowBackEnable}
            >
              <HomePage handleComToShow={this.handleComToShow} />
            </Layout>
          );
        default:
      }
    }
  }
}

export default withCookies(App);
